export const min = (arr: number[]): number => Math.min(...arr);
export const max = (arr: number[]): number => Math.max(...arr);
export const radiansToDegrees = (radians: number) => (radians * 180) / Math.PI;
export const calculateAngle = (
  x1: number,
  y1: number,
  x2: number,
  y2: number
): number => {
  const deltaX = x2 - x1;
  const deltaY = y2 - y1;
  return Math.atan2(deltaY, deltaX); // 라디안 단위
};
export function calculateDistance(
  x1: number,
  y1: number,
  x2: number,
  y2: number
): number {
  const dx = x2 - x1;
  const dy = y2 - y1;
  return Math.sqrt(dx * dx + dy * dy);
}

export const normalizeAngle = (angle: number) => {
  const normalized = ((angle + 180) % 360) - 180;
  return normalized < -180 ? normalized + 360 : normalized;
};

export function calculatePosition(
  a: number,
  position: [number, number, number]
): [number, number, number] {
  const horizontalIndex = Math.abs(a % 10);
  const thetaHorizontal = ((horizontalIndex - 1) / 8) * 2 * Math.PI; // 라디안 변환

  const verticalIndex = Math.floor(a / 10);
  const thetaVertical = (verticalIndex * 20 * Math.PI) / 180; // 라디안 변환

  const x = Math.sin(thetaHorizontal);
  const y = Math.cos(thetaHorizontal);
  const z = Math.sin(thetaVertical); // 높이

  return [position[0] + y, position[1] + z, position[2] + x];
}
